// import { textAlign } from '@mui/system';
import React from "react";
import { Button } from "react-bootstrap";
import { LINEAR_GRADIENT_BG } from "../const";

function CustomButton({
  title,
  width,
  height,
  background,
  color,
  onClick,
  marginleft,
  icon,
  iconright,
  border,
  borderRadius,
  display,
  justifyContent,
  margin,
  capacitys,
  fontweight,
  textshadow,
  disbale,
  disabled,
  padding,
  fontSize,
  type,
  marginTop
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type={type ? type: "submit"}
      style={{
        background: background ? background : LINEAR_GRADIENT_BG,
        color: color ? color : "white",
        width: width ? width : "100%",
        height: height ? height : "auto",
        textShadow: textshadow ? textshadow : "",
        fontWeight: fontweight ? fontweight : "",
        marginLeft: marginleft ? marginleft : "",
        alignItems: "center",
        border: border ? border : "none",
        borderRadius: borderRadius ? borderRadius : "0",
        display: display ? display : "flex",
        justifyContent: justifyContent ? justifyContent : "center",
        margin: margin ?? 0,
        opacity: capacitys ? capacitys : "",
        disabled: disbale ? disbale : "",
        gap: '.4em',
        padding: padding ? padding: ".5em",
        fontSize: fontSize? fontSize: '',
        marginTop: marginTop ? marginTop : "0"
      }}>
      {icon}
      {title}
      {iconright}
    </button>
  );
}

export default CustomButton;
